<div class="error-page">
  <div class="error-page__logo">
    <img src="assets/images/logo-dark.png" alt="Sinergial logo" />
  </div>

  <div class="error-page__content">
    <div class="error-page__code">
      @for (ch of statusCodeDigits(); track ch) {
        <span [class.error-page__code--accent]="$index % 2 === 1">{{ ch }}</span>
      }
    </div>
    <h4 class="error-page__title">{{ message }}</h4>
    <a class="error-page__btn" (click)="retry()">Reintentar</a>
  </div>

  <div class="error-page__help">
    <h5>¿Necesita ayuda?</h5>
    <div class="error-page__social">
      <a
        href="https://www.facebook.com/Oliverinformatica/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i class="pi pi-facebook"></i>
      </a>
      <a
        href="https://www.instagram.com/oliverinformatica/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i class="pi pi-instagram"></i>
      </a>
      <a
        href="https://www.linkedin.com/company/oliver-inform%C3%A1tica/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i class="pi pi-linkedin"></i>
      </a>
    </div>
    <div class="error-page__whatsapp">
      <a href="https://wa.me/5493585175140" target="_blank" rel="noopener noreferrer">
        <i class="pi pi-whatsapp"></i> Comercial
      </a>
      <a href="https://wa.me/5493585091929" target="_blank" rel="noopener noreferrer">
        <i class="pi pi-whatsapp"></i> HelpDesk
      </a>
    </div>
    <p class="error-page__footer">
      <a href="https://www.oliver.ar/" target="_blank" rel="noopener noreferrer">www.oliver.ar</a>
      &nbsp;|&nbsp;&copy; {{ year }}
    </p>
  </div>

  <div class="error-page__bg" aria-hidden="true"></div>
</div>
